import { Box } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";
import React from "react";

import { TutoringRelatedCategoriesQueryQuery } from "../../../shared/generated/graphql";
import { PillType, PillsComponent } from "../categories/CategoryPills";
import PageSectionTitle from "./PageSectionTitle";
import TutoringCategoriesQuery from "./queries/TutoringCategoriesQuery";
import { TUTORING_CATEGORY } from "./utils/tutoringConst";

export default function TutoringByTopics() {
  const { t } = useTranslation(
    "client\\components\\tutoring\\TutoringPage\\TutoringByTopics"
  );

  const { data: { categoryPage } = {}, loading } =
    useQueryWithPreviousData<TutoringRelatedCategoriesQueryQuery>(
      TutoringCategoriesQuery
    );

  const pills = [
    ...((categoryPage?.children as PillType[]) || []),
    ...((categoryPage?.related as PillType[]) || [])
  ];

  return (
    <>
      {!loading && (
        <Box sx={{ "& [role='presentation']": { marginTop: "0" } }}>
          <PageSectionTitle title={t("Explore more in Tutoring")} />
          <PillsComponent
            hasHeading={false}
            categories={pills}
            categorySlug={TUTORING_CATEGORY}
          />
        </Box>
      )}
    </>
  );
}
